import { AppProvider } from './provider';

export default function App() {
  return <AppProvider />;
}
